"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5254],{

/***/ 74995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32067);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54520);
// ../../../react-shim.js


// src/textarea.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone)
      delete clone[key];
  }
  return clone;
}

// src/textarea.tsx
var omitted = ["h", "minH", "height", "minHeight"];
var Textarea = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useStyleConfig */ .mq)("Textarea", props);
  const { className, rows, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const textareaProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(rest);
  const textareaStyles = rows ? omit(styles, omitted) : styles;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.textarea */ .m$.textarea, {
    ref,
    rows,
    ...textareaProps,
    className: cx("chakra-textarea", className),
    __css: textareaStyles
  });
});
Textarea.displayName = "Textarea";



/***/ }),

/***/ 55254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ContactForm": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(80419);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__(83234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__(74995);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./src/graphql/CreateContactQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateContact($data: CreateContactInput!) {\n    createContact(data: $data) {\n      errors\n      created\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var QueryCreateContact = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/components/Forms/ContactForm.tsx









var ContactForm = function(param) {
    var onParentSubmit = param.onSubmit;
    var ref, ref1, ref2, ref3;
    var toast = (0,dist_index_esm/* useToast */.pm)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(QueryCreateContact), 1), createContact = ref4[0];
    var ref5 = (0,index_esm/* useForm */.cI)(), register = ref5.register, setValue = ref5.setValue, handleSubmit = ref5.handleSubmit, watch = ref5.watch, reset = ref5.reset, _formState = ref5.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, ref1, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return createContact({
                            variables: {
                                data: values
                            }
                        });
                    case 3:
                        result = _ctx.sent;
                        if ((ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createContact) === null || ref1 === void 0 ? void 0 : ref1.created) {
                            toast({
                                title: "Kontaktanfrage geschickt.",
                                description: "Ihre Kontaktanfrage wurde empfangen. Wir melden uns schnellstm\xf6glich bei Ihnen. Vielen Dank!",
                                status: "success",
                                duration: 9000,
                                isClosable: true
                            });
                            reset();
                            onParentSubmit && onParentSubmit();
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                isInvalid: !!errors.name,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "name",
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                        id: "name",
                        placeholder: "Name"
                    }, register("name", {
                        required: true
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref = errors.name) === null || ref === void 0 ? void 0 : ref.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                mt: 4,
                isInvalid: !!errors.email,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "email",
                        children: "E-Mail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                        id: "email",
                        type: "email",
                        placeholder: "E-Mail"
                    }, register("email", {
                        required: true
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                mt: 4,
                isInvalid: !!errors.phone,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "phone",
                        children: "Telefon (optional)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                        id: "phone",
                        type: "tel",
                        placeholder: "Telefon"
                    }, register("phone"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref2 = errors.phone) === null || ref2 === void 0 ? void 0 : ref2.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                mt: 4,
                isInvalid: !!errors.comment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "comment",
                        children: "Nachricht / Frage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, (0,_object_spread/* default */.Z)({
                        rows: 5,
                        id: "comment"
                    }, register("comment", {
                        required: true
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref3 = errors.comment) === null || ref3 === void 0 ? void 0 : ref3.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                justifyContent: "flex-end",
                mt: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                    width: "100%",
                    variant: "roundBlue",
                    isLoading: isSubmitting,
                    type: "submit",
                    children: "Kontaktanfrage abschicken"
                })
            })
        ]
    });
};


/***/ }),

/***/ 50319:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useMutation; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14012);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82152);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14692);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30990);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66252);







function useMutation(mutation, options) {
    var client = (0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options === null || options === void 0 ? void 0 : options.client);
    (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .verifyDocumentType */ .Vp)(mutation, _parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .DocumentType.Mutation */ .n_.Mutation);
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, client = _a.client, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, options), { mutation: mutation });
        if (!ref.current.result.loading && !baseOptions.ignoreResults) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,_core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeOptions */ .J)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a, _b, _c;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new _errors_index_js__WEBPACK_IMPORTED_MODULE_6__/* .ApolloError */ .c({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted) === null || _b === void 0 ? void 0 : _b.call(_a, response.data);
            (_c = executeOptions.onCompleted) === null || _c === void 0 ? void 0 : _c.call(executeOptions, response.data);
            return response;
        }).catch(function (error) {
            var _a, _b, _c, _d;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            if (((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) || clientOptions.onError) {
                (_c = (_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onError) === null || _c === void 0 ? void 0 : _c.call(_b, error);
                (_d = executeOptions.onError) === null || _d === void 0 ? void 0 : _d.call(executeOptions, error);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        setResult({ called: false, loading: false, client: client });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ })

}]);